import { Type } from '@sinclair/typebox';
import { IsoDateTimeSchema, JsonObjectSchema, UuidSchema } from './common.js';
/**
 * Shared owner-facing notification contracts for scheduled action outcomes (COP-075/HUB-024).
 *
 * DTOs intentionally expose only redacted scheduler notification metadata.
 * They never include prompts, auth headers, OpenAPI specs, raw payloads,
 * tool arguments, tool outputs, or model output.
 *
 * `NotificationKindSchema` is the wire mirror of the `tf_notification_kind` pg
 * enum. Both sides must carry the same values or the notifications route
 * rejects its own row. `scheduled_succeeded` (COP-134 D3 / ATRU-03) is the
 * opt-in success notice, written only when the owning
 * `tf_scheduled_action.notifyOnSuccess` is true.
 *
 * `approval_execution_lapsed` (COP-148 D7) is the first kind that is NOT about
 * a schedule: the lapse sweeper writes it, unconditionally, when an approved
 * call whose execution never started is terminated.
 */
export const NotificationKindSchema = Type.Union([
    Type.Literal('scheduled_denied'),
    Type.Literal('scheduled_failed'),
    Type.Literal('scheduled_paused'),
    Type.Literal('scheduled_deferred_approval'),
    Type.Literal('scheduled_succeeded'),
    Type.Literal('approval_execution_lapsed'),
]);
export const NotificationSeveritySchema = Type.Union([
    Type.Literal('info'),
    Type.Literal('warning'),
    Type.Literal('error'),
]);
export const NotificationOwnerDtoSchema = Type.Object({
    id: UuidSchema,
    ownerUserId: UuidSchema,
    kind: NotificationKindSchema,
    scheduleId: Type.Union([UuidSchema, Type.Null()]),
    runId: Type.Union([UuidSchema, Type.Null()]),
    approvalId: Type.Union([UuidSchema, Type.Null()]),
    severity: NotificationSeveritySchema,
    title: Type.String({ minLength: 1, maxLength: 200 }),
    message: Type.String({ minLength: 1, maxLength: 2000 }),
    metadata: JsonObjectSchema,
    readAt: Type.Union([IsoDateTimeSchema, Type.Null()]),
    createdAt: IsoDateTimeSchema,
}, { additionalProperties: false });
export const NotificationListQuerySchema = Type.Object({
    limit: Type.Optional(Type.Integer({ minimum: 1, maximum: 100 })),
    unreadOnly: Type.Optional(Type.Boolean()),
}, { additionalProperties: false });
export const NotificationListResponseSchema = Type.Object({
    items: Type.Array(NotificationOwnerDtoSchema, { maxItems: 100 }),
}, { additionalProperties: false });
export const NotificationMarkReadParamsSchema = Type.Object({
    id: UuidSchema,
}, { additionalProperties: false });
export const NotificationMarkReadResponseSchema = Type.Object({
    notification: NotificationOwnerDtoSchema,
}, { additionalProperties: false });
//# sourceMappingURL=notifications.js.map